import { get, map } from 'lodash'
import { useQuery } from 'react-query'

export function useOrgUserAttributes() {
  const query = useQuery<{ status: string; data: any[] }>({
    queryKey: ['/v1/admin/organizations/:organizationId/usersattributes']
  })

  const result = map(get(query, 'data.data', []), attribute => {
    const { scimAttributeName, scimParentAttributeName, scimSchema } = attribute
    const prefix = scimParentAttributeName ? `${scimSchema}:${scimParentAttributeName}.` : `${scimSchema}:`

    return { ...attribute, urn: `${prefix}${scimAttributeName}` }
  })
  return result
}
